import digitalData from 'digital-data';
import { STASH } from '../constants';

const linkClicked = ({ output = {} }) => {
  const {
    route
  } = output;
  if (route === 'paintPurchaseHistory') {
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: 'my account: left nav click: paint purchase history'
        }
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  }
};

export const customerAccountNavigation = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('customer-account-navigation.link-click', linkClicked);
};